/**
 * @file 文档搜索页
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useMemo } from 'react';
import { Select, Tabs } from 'antd';
import classNames from 'classnames';

import Header from '../../components/header/Header';
import useHeaderHooks from '../../components/header/headerHooks';
import Footer from '../../components/footer/footer';
import useSearchAllStore from './searchAllHooks';
import SearchdocList from './components/searchdoc-list/SearchdocList';
import DocPagination from './components/doc-pagination/DocPagination';
import SearchInput from './components/search-input/SearchInput';

const SearchAll: React.FC = () => {
    const {
        keyword,
        searchResultList,
        loading,
        pagination,
        searchType,
        searchTypeList,

        onVersionChange,
        onSearch,
        onSearchTypeChange,
        onSearchItemClick,
        onPageChange
    } = useSearchAllStore();

    const headerHooks = useHeaderHooks();

    const [searchValue, version] = useMemo(() => {
        const params = new URLSearchParams(window.location.search.slice(1));
        return [params.get('q') || '', params.get('version') || ''];
    }, []);

    const searchVersionList = ['develop', '2.6', '2.5','2.4', '2.3', '2.2', '2.1', '2.0', '1.8'];

    return (
        <div className="page paddle-searchall-page">
            <Header {...headerHooks} />
            <div className="paddle-searchall-page-banner">
                <div>
                    <SearchInput
                        defaultValue={searchValue}
                        className="paddle-searchall-search"
                        placeholder="请输入搜索内容"
                        allowClear
                        enterButton="搜索"
                        loading={loading}
                        size="large"
                        onSearch={onSearch}
                    />

                    <Select
                        className="paddle-searchall-version-select"
                        size="large"
                        defaultValue={version}
                        onChange={onVersionChange}
                    >
                        {searchVersionList.map((item: string) => (
                            <Select.Option value={item} key={item}>
                                {item}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div className="paddle-searchall-page-banner-title">
                    为您找到以下“<em>{keyword}</em>"相关结果
                </div>
            </div>

            <div className="paddle-searchall-page-content">
                <div
                    className={classNames({
                        'paddle-searchall-page-mask': true,
                        'paddle-searchall-page-mask-loading': loading
                    })}
                />
                <Tabs className="paddle-searchall-tab" activeKey={searchType} onChange={onSearchTypeChange}>
                    {searchTypeList.map(item => (
                        <Tabs.TabPane tab={item.label} key={item.key} />
                    ))}
                </Tabs>
                {!loading && searchResultList.length === 0 && pagination.total === 0 && (
                    <div className="paddle-searchall-page-no-result">
                        <div className="paddle-searchall-page-no-result-img" />
                        <div className="paddle-searchall-page-no-result-text">抱歉，暂无搜索结果</div>
                    </div>
                )}

                <SearchdocList searchResultList={searchResultList} onSearchItemClick={onSearchItemClick} />

                <div className="paddle-searchall-page-pagination-wrap">
                    {pagination.total > 0 && <DocPagination {...pagination} onChange={onPageChange} />}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SearchAll;
